import Input from "app/components/Input"
import Textarea from "app/components/Icons/Textarea"
import { Select } from "app/components/Select"
import React, { useState } from "react"
import Assignee from "../containers/Home/components/ColumnCustomize/Assignee"
import { DropdownIcon } from "app/components/Icons"

export default function AddComponent() {
    return (
        <div className="flex flex-col px-[24px] py-4 pt-[12px] gap-4">
            <div className="flex flex-col gap-y-4">
                <Input
                    label="Component name"
                    placeholder="Enter component name..."
                    id='component-name'
                    inputClassName='!h-[48px] !gap-[0px]'
                    innerContainerClassName="!gap-[0px]"
                />
                <Assignee
                    dropdownTrigger={
                     <div>
                        <Input
                        label="Component lead"
                        placeholder="Choose lead"
                        id='component-lead'
                        inputClassName='!h-[48px] !gap-[0px]'
                        innerContainerClassName="!gap-[0px]"
                        endIcon={<DropdownIcon size={16} />}
                        />
                    </div>
                    }
                    assignedTo={[]}
                    dropdownPlaceholder="Search by members'name or role"
                    dropdownContainerClassName="max-h-[280px] overflow-scroll"
                    className="min-w-[345px]"

                    />
                <Assignee
                    dropdownTrigger={
                    <div>
                        <Input
                        label="Default assignee"
                        placeholder="Enter assignee"
                        id='default-assignee'
                        inputClassName='!h-[48px] !gap-[0px]'
                        innerContainerClassName="!gap-[0px]"
                        endIcon={<DropdownIcon size={16} />}
                        />
                    </div>
                    }
                    assignedTo={[]}
                    dropdownContainerClassName="max-h-[280px] overflow-scroll"
                    className="min-w-[345px]"
                    /> 
                <Textarea
                    label="Component description"
                    placeholder="Enter Component description"
                    id='component-description'
                    inputClassName='!gap-[0px]'
                    innerContainerClassName="!gap-[0px]"
                />
            </div>
        </div>
    )
}